<template>
  <div :class="['new-comment d-flex flex-column border rounded mx-3', {focused:focusedOnNewMessage}]">
    <BTextarea
      ref="input"
      v-model="newMessage"
      :disabled="saving || !commit"
      placeholder="New comment..."
      class="border-0"
      @keydown.enter.shift="submit"
      @focus="focusedOnNewMessage = true"
      @blur="focusedOnNewMessage = false"
    />
    <div class="d-flex flex-row align-items-center justify-content-end gap-2 p-1 border-top">
      <div class="text-muted small flex-grow-1 ps-2">
        Shift+enter to submit
      </div>
      <button class="btn btn-sm btn-primary" @click="submit" :disabled="!newMessage || saving || !commit">
        <SpinnerView v-if="saving" class="me-1" small />Add comment
      </button>
    </div>
  </div>
</template>

<script>
import BTextarea from "@/components/common/BTextarea.vue";
import SpinnerView from "@/components/common/SpinnerView.vue";

export default {
  components: {SpinnerView, BTextarea},
  props: {
    commit: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      newMessage: '',
      saving: false,
      focusedOnNewMessage: false
    };
  },
  methods: {
    async submit() {
      try {
        this.saving = true;
        await this.commit(this.newMessage);
        this.newMessage = '';
        this.$nextTick(() => this.$refs.input.$el.focus());
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>

<style scoped>
.new-comment {
  z-index: 1;
  transition: border-color 250ms;
}
.new-comment.focused {
  border-color: var(--bs-primary) !important;
}
.new-comment textarea {
  font-size: 0.875rem;
}
</style>
